module.exports = __webpack_public_path__ + "media/images/member-database-4-5c58b01baaab95b1e84b45507f4c4a48.svg";